var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUploadFile = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 36,
  height: 42,
  viewBox: "0 0 46 55",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M35.008 11.005v.5h10.367c.063 0 .121.051.121.128v42.739a.123.123 0 0 1-.12.128H.62a.123.123 0 0 1-.121-.128V.628C.5.551.558.5.621.5h34.265c.063 0 .121.05.121.128v10.377ZM.742 53.743v.5h44.51V11.762H34.887a.123.123 0 0 1-.121-.129V.757H.743v52.986Z",
  stroke: "url(#upload-file_svg__a)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m34.995.58.002.002 10.462 10.96v.001a.134.134 0 0 1-.001.186.115.115 0 0 1-.083.033.12.12 0 0 1-.086-.037L34.83.765a.134.134 0 0 1 0-.184.117.117 0 0 1 .165 0Z",
  stroke: "url(#upload-file_svg__b)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.368 45.087v.5h21.264V41.349c0-.078.058-.128.121-.128s.122.05.122.128v4.366a.124.124 0 0 1-.122.128H12.246a.124.124 0 0 1-.12-.128v-4.366c0-.078.058-.128.12-.128.063 0 .122.05.122.128v3.738Z",
  stroke: "url(#upload-file_svg__c)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M22.998 40.824a.123.123 0 0 1-.121-.129V23.708c0-.077.058-.128.121-.128s.122.051.122.128v16.987a.123.123 0 0 1-.122.129Z",
  stroke: "url(#upload-file_svg__d)"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "m23.35 24.247-.355-.36-.356.36-7.382 7.465a.117.117 0 0 1-.166 0 .134.134 0 0 1 0-.184l7.819-7.906a.117.117 0 0 1 .166 0l7.819 7.906a.134.134 0 0 1 0 .184.118.118 0 0 1-.081.035.118.118 0 0 1-.082-.035l-7.382-7.465Z",
  stroke: "url(#upload-file_svg__e)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "upload-file_svg__a",
  x1: 0,
  y1: 37,
  x2: 46,
  y2: 37,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "red"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#005AAA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upload-file_svg__b",
  x1: 1.5,
  y1: 12,
  x2: 46,
  y2: 12,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "red"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#005AAA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upload-file_svg__c",
  x1: 0.5,
  y1: 46,
  x2: 45.5,
  y2: 46,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "red"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#005AAA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upload-file_svg__d",
  x1: 1.5,
  y1: 41,
  x2: 45.5,
  y2: 41,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "red"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#005AAA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upload-file_svg__e",
  x1: 2,
  y1: 32,
  x2: 45.5,
  y2: 32,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "red"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#005AAA"
})))));
export { SvgUploadFile as ReactComponent };
export default __webpack_public_path__ + "/assets/25b44852f475f605de6ed043fdd7602d.svg";